import { PERMISSIONS } from '../../constants';
import list from './AttendantGoalOfferList';
import show from './AttendantGoalOfferShow';

// Interno PontuaX. O nome é o path da API (GET /attendant-goal-offers). O gate de verdade (isAdmin E
// attendant-goal-internal) é o InternalGate das telas; `permissions` aqui só decide se o resource é registrado.
export default {
  list,
  show,
  name: 'attendant-goal-offers',
  permissions: [PERMISSIONS.ATTENDANT_GOAL_INTERNAL],
};
